import { Const, ConfigFinishDefault } from '@app/shared';
import { DynamicContentFormComponent } from '@app/components/dynamic-content-form/dynamic-content-form.component';
import { LoadTaskDataService } from './shared/load-task.data.service';
import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  ComponentRef,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { HelperFlowService } from '@app/shared/services/helper-flow.service';
import { Context } from '@app/shared';


@Component({
  selector: 'iw-load-task',
  templateUrl: './load-task.component.html',
  styleUrls: ['./load-task.component.scss'],
  providers: [
    LoadTaskDataService,
    HelperFlowService
  ],
})
export class LoadTaskComponent implements OnInit {
  // tarea de liquidacion
  task: any;
  // contexto de la tarea
  context: Partial<Context> = {};
  // contiene el id de la liquidacion
  liquidacion_id: number;
  // bandera que permite cerrar el modal despues de finalizar la tarea
  isfinish = true;
  // emite un evento al cerrar
  @Output() close: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  // contiene el ide del tramite de liquidacion
  @Input() tramite_id: any;
  // Contenedor del formulario dinamico para auto guardado
  @ViewChild('componentFormAutoSave', { read: ViewContainerRef })
  private componentFormAutoSave: ViewContainerRef;
  // Referencia a el componente de renderizacion de formulario de tareas
  private componentRef: ComponentRef<DynamicContentFormComponent>;

  constructor(
    private ltds: LoadTaskDataService,
    private hfs: HelperFlowService,
    private cfr: ComponentFactoryResolver,
  ) { }

  async ngOnInit() {
    if (this.tramite_id) {
      const tramitComplete = await this.ltds.getInstance(this.tramite_id);
      this.liquidacion_id = tramitComplete.codigo_liquidacion;
      if (tramitComplete.liquidacion) {
        const actividades = this.hfs.refineActivities(tramitComplete.actividades);
        actividades.forEach(act => {
          this.hfs.refineTasks(act);
          act.tareas.forEach(tsk => {
              if (tsk.liquidacion === true && tsk.activo === true) {
                this.task = tsk;
                return;
              }
          });
        });
        if(this.task){
          const taskData = await this.ltds.getInstancePrincipalTask(this.task.id);
              if (taskData){
                this.task.documentos = taskData.documentos;
                this.task.documentos_modificacion = taskData.documentos_modificacion;
                this.task.tarea_asociacion = taskData.tarea_asociacion;
                this.task.tarea_condicion = taskData.tarea_condicion;
                this.task.tarea_finalizacion = taskData.tarea_finalizacion;
                this.task.historial_rechazo = taskData.historial_rechazo;
              }
        }
      }
    }
    this.loadDinamicContentForm();
  }

  loadDinamicContentForm() {
    if (this.componentFormAutoSave) {
      this.componentFormAutoSave.clear();
    }
    const factory = this.cfr.resolveComponentFactory(DynamicContentFormComponent);
    this.componentRef = this.componentFormAutoSave.createComponent(factory);
    this.componentRef.instance.task = this.task;
    this.componentRef.instance.liquidation = true;
    this.componentRef.instance.context = {
      task: this.task,
      typeProcess: 'process'
    };
    this.componentRef.instance.liquidation = true;
    this.componentRef.instance.event.subscribe((event: any) => this.manageEvent(event));
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @private
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof TaskComponent
   */
  private async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }

  /**
   * Finalizar la tarea según su tipo.
   *
   * @param {*} data
   * @param skip
   * @memberof TaskComponent
   */
  async finish(data: any, skip: boolean = false) {
    let isFinished: boolean;
    switch (this.task.tarea_tipo.nombre) {
      // Ninguna, condición y forma especifica
      case Const.TYPES_TASK.none:
      case Const.TYPES_TASK.condition:
      case Const.TYPES_TASK.form:
        if (data['id_opciones'] && data['id_opciones'].length) {
          let f = true;
          isFinished = true;
          await this.asyncForEach(data['id_opciones'], async (el: number) => {
            const d: ConfigFinishDefault = {
              tarea: data['tarea'],
              id_opcion: el
            };
            f = await this.ltds.finishDefault(d);
            if (!f) {
              isFinished = false;
            }
          });
        } else {
          isFinished = await this.ltds.finishDefault(data as ConfigFinishDefault);
        }
        if (isFinished) {
          // cerrar
          this.isfinish = true;
          this.close.emit(true);
        }
        break;
    }
  }


  manageEvent(e: any) {
    let skipFinish = false;
    if (e.hasOwnProperty('params')) {
      skipFinish = e.params.hasOwnProperty('skip') ? e.params.skip : false;
    }
    if (e.type === 'finish') {
      this.finish(e.data, skipFinish);
      this.isfinish = false;
      return;
    }
    if (e.type === 'closeForm' && this.isfinish) {
      if (this.task.fecha_finalizacion !== null) {
        this.close.emit(true);
        return;
      }
      this.close.emit(false);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/instance-liquidation/load-task/load-task.component.ts